import request from "@/core/services/request";

export function registerUser(data) {
  return request({
    url: "/user/register/",
    method: "post",
    data: data,
  });
}

export function resetPassword(data) {
  return request({
    url: "/user/reset/password/",
    method: "post",
    data: data,
  });
}

export function userInfo() {
  return request({
    url: "/instance/USER/",
    method: "get",
  });
}

export function omsUserInfo() {
  return request({
    url: "/oms/user/info/",
    method: "get",
  });
}

export function updatePassword(data) {
  return request({
    url: "/api/v1/user/update/password/",
    method: "put",
    data: data,
  });
}

export function updateEmail(data) {
  return request({
    url: "/api/v1/user/update/email/",
    method: "put",
    data: data,
  });
}

export function resetToken() {
  return request({
    url: "/api/v1/user/reset/token/",
    method: "get",
  });
}
